{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-scope_2022-12-31/ssmt-scope_2022-12-31_role-020000",
  "definition": "[020000] Scope of Filing",
  "sheetId": "ScopeOfFiling",
  "label": "Scope of Filing",
  "controls": [
    {
      "qname": "ssmt:DateOfFinancialStatementsApprovedByBoardOfDirectors",
      "label": "Date of financial statements approved by Board of Directors",
      "type": "Date",
      "ui": { "control": "date" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "warnings": [
        {
          "id": "approval-date-before-year-end",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of financial statements approved by Board of Directors\" MUST be greater than \"Company's current financial year end date\"",
            "comparisonOperator": "lte",
            "compareWith": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:CompanyCurrentFinancialYearEndDate"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DateOfCirculationOfFinancialStatementsAndReportsToMembers",
      "label": "Date of circulation of financial statements and reports to members",
      "type": "Date",
      "ui": { "control": "date" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "warnings": [
        {
          "id": "circulation-date-before-approval-date",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of circulation of financial statements and reports to members\" must be equal to or greater than \"Date of financial statements approved by Board of Directors\".",
            "comparisonOperator": "lt",
            "compareWith": {
              "sheet": "scopeOfFiling",
              "field": "ssmt:DateOfFinancialStatementsApprovedByBoardOfDirectors"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DateOfFinancialStatementsAndReportsOfDirectorsAndAuditorsLaidInAnnualGeneralMeeting",
      "label": "Date of financial statements and reports of the directors and auditors (if applicable) laid in annual general meeting",
      "type": "Date",
      "ui": { "control": "date" },
      "required": false,
      "warnings": [
        {
          "id": "agm-date-not-greater-than-auditor-report-date",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of financial statements and reports of the directors and auditors (if applicable) laid in annual general meeting\" must be greater than \"Date of signing auditor's report\".",
            "comparisonOperator": "lte",
            "compareWith": {
              "sheet": "auditorsReport",
              "field": "ssmt:DateOfSigningAuditorsReport"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DateOfStatutoryDeclaration",
      "label": "Date of Statutory Declaration",
      "type": "Date",
      "ui": { "control": "date" },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "warnings": [
        {
          "id": "statutory-declaration-before-year-end",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "\"Date of Statutory Declaration\" MUST be greater than \"Company's current financial year end date\"",
            "comparisonOperator": "lte",
            "compareWith": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:CompanyCurrentFinancialYearEndDate"
            }
          }
        }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOnWhetherCompanysSharesAreTradedOnAnyOfficialStockExchange",
      "label": "Disclosure on whether company's shares are traded on any official stock exchange",
      "type": "TypesOfDisclosureOnWhetherCompanysSharesAreTraded",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "hideWhen": {
          "field": "ssmt-dei:TypeOfSubmission",
          "values": ["FS-EPC"]
        },
        "showInSections": ["particulars"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfRegulationAppliedDuringIncorporationOfCompany",
      "label": "Disclosure of the regulation applied during incorporation of the company",
      "type": "TypesOfDisclosureOfRegulationAppliedDuringIncorporationOfCompany",
      "ui": {
        "control": "select",
        "enumSource": "type:TypesOfDisclosureOfRegulationAppliedDuringIncorporationOfCompany",
        "showInSections": ["particulars"]
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOnWhetherCompanyInvolvedAsManagementCompanyUnderInterestSchemeAct2016",
      "label": "Disclosure on whether company involved as management company under Interest Scheme Act 2016",
      "type": "TypesOfDisclosureOnWhetherCompanyInvolvedAsManagementCompanyUnderInterestSchemeAct2016",
      "ui": {
        "control": "select",
        "enumSource": "type:TypesOfDisclosureOnWhetherCompanyInvolvedAsManagementCompanyUnderInterestSchemeAct2016",
        "showInSections": ["particulars"]
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfWhetherCompanyRegulatedByBankNegaraMalaysiaAtFinancialYearEnd",
      "label": "Disclosure of whether company regulated by Bank Negara Malaysia at the financial year end",
      "type": "BankNegaraMalaysiaRegulationStatusType",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "showInSections": ["particulars"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:MSICCode",
      "label": "MSIC Code (Business 1)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "msicCode2008",
        "businessTable": true,
        "businessRow": 1
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt:BusinessOneMember"]
      }
    },
    {
      "qname": "ssmt:DescriptionOfBusiness",
      "label": "Description of Business (Business 1)",
      "type": "String",
      "ui": {
        "control": "text",
        "readonly": true,
        "placeholder": "e.g., Wholesale of general merchandise",
        "businessTable": true,
        "businessRow": 1
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt:BusinessOneMember"]
      }
    },
    {
      "qname": "ssmt:MSICCode",
      "label": "MSIC Code (Business 2)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "msicCode2008",
        "businessTable": true,
        "businessRow": 2
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt:BusinessTwoMember"]
      }
    },
    {
      "qname": "ssmt:DescriptionOfBusiness",
      "label": "Description of Business (Business 2)",
      "type": "String",
      "ui": {
        "control": "text",
        "readonly": true,
        "placeholder": "",
        "businessTable": true,
        "businessRow": 2
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt:BusinessTwoMember"]
      }
    },
    {
      "qname": "ssmt:MSICCode",
      "label": "MSIC Code (Business 3)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "msicCode2008",
        "businessTable": true,
        "businessRow": 3
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt:BusinessThreeMember"]
      }
    },
    {
      "qname": "ssmt:DescriptionOfBusiness",
      "label": "Description of Business (Business 3)",
      "type": "String",
      "ui": {
        "control": "text",
        "readonly": true,
        "placeholder": "",
        "businessTable": true,
        "businessRow": 3
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt:BusinessThreeMember"]
      }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
      "label": "Description on whether company had applied for any exemption, waiver, relief or extension of time with regards to annual return or financial statements and reports from Registrar or Minister",
      "type": "YesNoItemType",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForExemptionFromCoincidingForeignSubsidiaryFinancialYearEndWithHoldingCompany",
      "label": "Description on whether company had applied for exemption from coinciding foreign subsidiary financial year end with holding company",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForExemptionFromFilingFinancialStatementsAndReportsInFullXBRLFormat",
      "label": "Description on whether company had applied for exemption from filing financial statements and reports in full XBRL format",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedToWaiveLodgementOfFinancialStatementsByForeignCompany",
      "label": "Description on whether company had applied to waive lodgement of financial statements by foreign company",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForReliefFromRequirementsAsToFormAndContentsOfDirectorsReport",
      "label": "Description on whether company had applied for relief from requirements as to form and contents of Director's report",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForReliefFromRequirementsAsToFormAndContentsOfFinancialStatements",
      "label": "Description on whether company had applied for relief from requirements as to form and contents of financial statements",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeForCirculationOfFinancialStatementsAndReports",
      "label": "Description on whether company had applied for extension of time for circulation of financial statements and reports",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeToLodgeFinancialStatementsAndReports",
      "label": "Description on whether company had applied for extension of time to lodge financial statements and reports",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeForCirculationAndHoldingAnnualGeneralMeeting",
      "label": "Description on whether company had applied for extension of time for circulation and holding annual general meeting",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeToLodgeAnnualReturn",
      "label": "Description on whether company had applied for extension of time to lodge annual return",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DescriptionOnWhetherCompanyHadAppliedAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardsToAnnualReturnOrFinancialStatementsAndReportsToMinister",
      "label": "Description on whether company had applied any exemption, waiver, relief or extension of time with regards to annual return or financial statements and reports to Minister",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "conditionalOn": "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
        "showWhen": "Yes",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:MethodUsedForPreparingStatementOfFinancialPosition",
      "label": "Method used for preparing Statement of Financial Position",
      "type": "TypeOfMethodUsedForPreparingStatementOfFinancialPosition",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss",
      "label": "Method used for preparing Statement of Profit or Loss",
      "type": "TypeOfMethodUsedForPreparingStatementOfProfitOrLoss",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "hideWhen": {
          "field": "ssmt-dei:TypeOfSubmission",
          "values": ["KFI-MFRS", "KFI-MPERS"]
        },
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome",
      "label": "Method used for preparing Statement of Comprehensive Income",
      "type": "TypeOfMethodUsedForPreparingStatementOfComprehensiveIncome",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "hideWhen": {
          "field": "ssmt-dei:TypeOfSubmission",
          "values": ["KFI-MFRS", "KFI-MPERS"]
        },
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity",
      "label": "Method used for representing changes in an entity's equity",
      "type": "TypesOfMethodUsedForRepresentingChangesInAnEntitysEquity",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "hideWhen": {
          "field": "ssmt-dei:TypeOfSubmission",
          "values": ["FS-MFRS", "KFI-MFRS"]
        },
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:MethodUsedForPreparingStatementOfCashFlows",
      "label": "Method used for preparing Statement of Cash Flows",
      "type": "TypeOfMethodUsedForPreparingStatementOfCashFlows",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "hideWhen": {
          "field": "ssmt-dei:TypeOfSubmission",
          "values": ["KFI-MFRS", "KFI-MPERS"]
        },
        "showInSections": ["approved-application"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOnWhetherComparativePeriodValuesAreRestated",
      "label": "Disclosure on whether comparative period values are restated",
      "type": "YesNoItemType",
      "ui": {
        "control": "text",
        "readonly": true,
        "inheritFrom": "filingInfo",
        "showInSections": ["subsequent-changes"]
      },
      "required": false,
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOnWhetherOpeningStatementChangedDueToChangesInAccountingStandards",
      "label": "Disclosure on whether opening statements changed due to changes in accounting standards",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "showInSections": ["subsequent-changes"]
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOnWhetherReclassificationOfPreviousFinancialStatementsChangedDueToChangesInAccountingStandards",
      "label": "Disclosure on whether reclassification of previous financial statements changed due to changes in accounting standards",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "showInSections": ["subsequent-changes"]
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOnWhetherCompanyChangedDurationOfFinancialReportingPeriod",
      "label": "Description on whether company changed the duration of financial reporting period",
      "type": "YesNoItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:YesNoItemType",
        "showInSections": ["subsequent-changes"]
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-clbg:CategoriesOfObjectsObject1",
      "label": "Categories of Objects (Object 1)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "TypeOfDisclosureOnCategoriesOfObjectsOfCompaniesLimitedByGuarantee",
        "clbgTable": true,
        "clbgRow": 1,
        "showForSubmissionType": ["FS-CLBG", "KFI-CLBG"],
        "showInSections": []
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt-clbg:ObjectOneMember"]
      }
    },
    {
      "qname": "ssmt-clbg:SubCategoriesOfObjectsObject1",
      "label": "Sub-categories of Objects (Object 1)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "TypeOfDisclosureOnSubCategoriesOfObjectsOfCompaniesLimitedByGuarantee",
        "clbgTable": true,
        "clbgRow": 1,
        "showForSubmissionType": ["FS-CLBG", "KFI-CLBG"],
        "showInSections": []
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt-clbg:ObjectOneMember"]
      }
    },
    {
      "qname": "ssmt-clbg:CategoriesOfObjectsObject2",
      "label": "Categories of Objects (Object 2)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "TypeOfDisclosureOnCategoriesOfObjectsOfCompaniesLimitedByGuarantee",
        "clbgTable": true,
        "clbgRow": 2,
        "showForSubmissionType": ["FS-CLBG", "KFI-CLBG"],
        "showInSections": []
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt-clbg:ObjectTwoMember"]
      }
    },
    {
      "qname": "ssmt-clbg:SubCategoriesOfObjectsObject2",
      "label": "Sub-categories of Objects (Object 2)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "TypeOfDisclosureOnSubCategoriesOfObjectsOfCompaniesLimitedByGuarantee",
        "clbgTable": true,
        "clbgRow": 2,
        "showForSubmissionType": ["FS-CLBG", "KFI-CLBG"],
        "showInSections": []
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt-clbg:ObjectTwoMember"]
      }
    },
    {
      "qname": "ssmt-clbg:CategoriesOfObjectsObject3",
      "label": "Categories of Objects (Object 3)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "TypeOfDisclosureOnCategoriesOfObjectsOfCompaniesLimitedByGuarantee",
        "clbgTable": true,
        "clbgRow": 3,
        "showForSubmissionType": ["FS-CLBG", "KFI-CLBG"],
        "showInSections": []
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt-clbg:ObjectThreeMember"]
      }
    },
    {
      "qname": "ssmt-clbg:SubCategoriesOfObjectsObject3",
      "label": "Sub-categories of Objects (Object 3)",
      "type": "String",
      "ui": {
        "control": "select",
        "enumSource": "TypeOfDisclosureOnSubCategoriesOfObjectsOfCompaniesLimitedByGuarantee",
        "clbgTable": true,
        "clbgRow": 3,
        "showForSubmissionType": ["FS-CLBG", "KFI-CLBG"],
        "showInSections": []
      },
      "required": false,
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": ["ssmt-clbg:ObjectThreeMember"]
      }
    }
  ]
}
